import { Box, Stack, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import { useEffect, useState } from "react";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";

function StrongKidsCreate() {
  //OAERDOGAN;427326;08112024 MADDE ILE STRONG KIDS YAPILDI
  //IDOGAN;453312;28032025;REVIZE
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  useEffect(() => {
    //medcardService.create('data1',5);
    //medcardService.delete('data2',5);
    //medcardService.save('data3',5);
  }, []);

  const handleCreateMedcardData = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };
  const handleSaveMedcard = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const { t } = useTranslate();
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton onClick={handleSaveMedcard} />
        <ByzMuiAddButton onClick={handleCreateMedcardData} />
        <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
        <ByzNursePrintButton2 />
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={9} xs={6} container direction={"column"} spacing={3}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("datetime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("createdby")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "100%", maxWidth: "300px" }}
                  disabled
                  label={t("createdby")}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.disease-or-surgery")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiRadioButton typographyText="yes,no" layout="row" border="none"/>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.subjective-assessment")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiRadioButton typographyText="yes,no" layout="row" border="none" />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.any-of-following")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiRadioButton typographyText="yes,no" layout="row" border="none"/>
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.diarrhea-or-vomiting")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("select")}
                  placeholder={t("select")}
                /> 
              </Grid>
            </Grid>
            <Grid
              container 
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.reduced-intake")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("select")}
                  placeholder={t("select")}
                />
              </Grid>
            </Grid>
 
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.previous-intervention")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("select")}
                  placeholder={t("select")}
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.insufficient-intake-due-to-pain")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params: any) => <ByzMuiTextField {...params} />}
                  options={[]}
                  label={t("select")}
                  placeholder={t("select")}
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.weight-loss-or-no-gain")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiRadioButton typographyText="yes,no" layout="row" border="none"/>
              </Grid>
            </Grid>

            <Grid
              md={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "left" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                {t("strong-kids.malnutrition-diseases-list-title")}
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.anorexia-nervosa")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.burns")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{ marginLeft: "30px", textAlign: "left" }}
                >
                  {t("strong-kids.bronchopulmonary-dysplasia")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px", 
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.celiac")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.cystic-fibrosis")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.dysmaturity-prematurity")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.chronic-heart-disease")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.inflammatory-bowel-disease")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.cancer")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.chronic-liver-disease")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.pancreatitis")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.chronic-renal-failure")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.short-bowel-syndrome")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.muscle-diseases")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.metabolic-diseases")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.trauma")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.mental-retardation")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.planned-surgery")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "56px",
                    border: "none",
                    borderRadius: "7px",
                    display: "flex",
                    paddingLeft: "5px",
                  }}
                >
                  <ByzMuiCheckBox />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("strong-kids.other-diseases")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <TextField
                  sx={{ width: "300px" }}
                  id="outlined-basic"
                  label={t("strong-kids.other-diseases")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "left" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                {t("other")}
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                  }}
                  fontWeight={500}
                  fontSize={"14px"}
                >
                  {t("score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  disabled
                  sx={{ width: "300px" }}
                  label={t("score")}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                  }}
                  fontWeight={500}
                  fontSize={"14px"}
                >
                  {t("note")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  disabled
                  sx={{ width: "300px" }}
                  label={t("note")}
                />
              </Grid>
            </Grid>

            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default StrongKidsCreate;
